export const HolidayTypeEnum = {
  REGULAR: "REGULAR",
  SPECIAL: "SPECIAL"
}

export const HolidayTypeList = [
  "REGULAR",
  "SPECIAL"
]
